import type { ReactNode } from 'react';
import { KitButton } from './button';

export type StepState = 'done' | 'current' | 'todo' | 'error';
export interface StepItem {
  id: string;
  label: string;
  detail?: ReactNode;
  state: StepState;
}
export interface StepperProps {
  items: readonly StepItem[];
  locale: string;
  label: string;
  stateLabel(state: StepState): string;
  onStep?(id: string): void;
}
export function Stepper({ items, locale, label, stateLabel, onStep }: StepperProps) {
  const count = new Intl.NumberFormat(locale);
  return (
    <ol className="pc-stepper" aria-label={label}>
      {items.map((item, index) => (
        <li
          key={item.id}
          className="pc-step"
          data-state={item.state}
          aria-current={item.state === 'current' ? 'step' : undefined}
        >
          <span aria-hidden="true">{count.format(index + 1)}</span>
          {onStep ? (
            <KitButton
              variant="quiet"
              onClick={() => onStep(item.id)}
              aria-label={`${item.label} · ${stateLabel(item.state)}`}
            >
              {item.label}
            </KitButton>
          ) : (
            <strong aria-label={`${item.label} · ${stateLabel(item.state)}`}>{item.label}</strong>
          )}
          {item.detail && <div>{item.detail}</div>}
        </li>
      ))}
    </ol>
  );
}
